import { render, staticRenderFns } from "./EpHomeCalendar.vue?vue&type=template&id=1a31b0dd&"
import script from "./EpHomeCalendar.vue?vue&type=script&lang=js&"
export * from "./EpHomeCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports